// src/components/hollo-language-menu.ts
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { holloLanguageMenuStyles } from "./hollo-language-menu-styles";

export type LanguageOpt = {
  code: string;
  name: string;
  flag_url: string;
  is_chat_default?: boolean;
};

@customElement("hollo-language-menu")
export class HolloLanguageMenu extends LitElement {
  @property({ type: Array }) languages: LanguageOpt[] = [];
  @property({ type: String }) selected = "";
  @property({ type: String }) align: "left" | "right" = "right";

  private handleDocumentClick = (event: Event) => {
    const path = event.composedPath();
    // Don't close if clicking on the flag button (let the toggle handle it)
    const flagButton = path.find((el) => 
      el instanceof Element && 
      (el.classList?.contains("flag-btn") || el.classList?.contains("hollo-flag-btn"))
    );
    if (!path.includes(this) && !flagButton) {
      this.close();
    }
  };

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("mousedown", this.handleDocumentClick, true);
    document.addEventListener("touchstart", this.handleDocumentClick, true);
  }

  disconnectedCallback() {
    document.removeEventListener("mousedown", this.handleDocumentClick, true);
    document.removeEventListener("touchstart", this.handleDocumentClick, true);
    super.disconnectedCallback();
  }

  private select(code: string) {
    this.dispatchEvent(
      new CustomEvent("select-language", {
        detail: { code },
        bubbles: true,
        composed: true,
      })
    );
  }

  private close() {
    this.dispatchEvent(new CustomEvent("close-language-menu"));
  }

  render() {
    return html`
      <div class="hollo-lang-menu ${this.align === "left" ? "align-left" : ""}" role="menu" aria-label="Choose Language">
        <div class="hollo-lang-list">
          ${this.languages.map(
            (l, i) => html`
              <button
                class="hollo-lang-item ${this.selected === l.code
                  ? "hollo-selected"
                  : ""}"
                role="menuitemradio"
                aria-checked=${this.selected === l.code}
                @click=${() => this.select(l.code)}
              >
                <span class="hollo-li-left">
                  <span class="hollo-li-flag">
                    <img src="${l.flag_url}" alt="" />
                  </span>
                  <span class="hollo-li-label">${l.name}</span>
                </span>
                <span class="hollo-li-radio"
                  ><span class="hollo-dot"></span
                ></span>
              </button>
              ${i < this.languages.length - 1
                ? html`<div class="hollo-li-divider"></div>`
                : null}
            `
          )}
        </div>
      </div>
    `;
  }

  static styles = holloLanguageMenuStyles;
}

declare global {
  interface HTMLElementTagNameMap {
    "hollo-language-menu": HolloLanguageMenu;
  }
}
